import '../../styles/animate.css';

function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}

const sizes = {
    sm: 5,
    md: 10,
    lg: 20,
};

export default function AnimatedBorderTrail({
    children,
    className,
    duration = '5s',
    trailColor = 'black',
    trailSize = 'md',
    contentClassName,
    ...props
}) {
    return (
        <div
            {...props}
            className={cn(
                'relative h-fit w-fit overflow-hidden rounded-[4px] bg-gray-200 dark:!bg-[#e7e7e7] dark:!bg-opacity-[.1] p-px',
                className
            )}
        >
            <div
                className={`absolute inset-0 h-full w-full animate-trail`}
                style={{
                    '--duration': duration ?? '10s',
                    '--angle': '0deg',
                    background: `conic-gradient(from var(--angle) at 50% 50%, transparent ${
                        100 - sizes[trailSize]
                    }%, var(--trail-color))`,
                }}
            />
            <div
                className={cn(
                    'relative h-full w-full overflow-hidden rounded-[3px] bg-white',
                    contentClassName
                )}
            >
                {children}
            </div>
        </div>
    );
}
